import "./style.scss";
import warningModalIcon from "../../assets/images/warning_modal.svg";
import { Button, message } from "antd";
import { useEffect, useState } from "react";

const CityWarningModal = ({
  isOpen,
  onClose,
  text,
  onOK,
  loader,
  confirmText = "Please confirm your city",
}) => {
  const [city, setCity] = useState("");
  const [step, setStep] = useState("form");
  const [placement, setPlacement] = useState("bottomRight");

  useEffect(() => {
    setPlacement(window.screen.width < 1440 ? "center" : "bottomRight");
  }, []);

  console.log("placement : ", placement);
  if (!isOpen) return null;

  const handleSubmit = () => {
    setStep("confirm");
  };

  const handleConfirm = () => {
    onOK(city.trim());
  };

  const handleCancel = () => {
    setStep("form");
  };

  return (
    <div className="warning-modal-overlay">
      <div className="warning_modal_wrapper">
        <div className="warning_modal_container_top">
          <div className="warning_icon">
            <img src={warningModalIcon} alt="warningModalIcon" />
          </div>
        </div>

        <div
          className="warning-modal-container"
          onClick={(e) => e?.stopPropagation()}
        >
          <div className="warning_modal_container_bottom">
            <h1>Action Required!</h1>

            {step === "form" && (
              <>
                <div className="warning_modal_content">
                  <p>{text}</p>
                  <input
                    type="text"
                    name="city"   
                    id="city"
                    className="customCityInput"
                    placeholder="Enter your city" 
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                  />  
                </div>

                <div className="warning_modal_btn">
                  <Button disabled={!city} onClick={handleSubmit}>
                    Save and Continue
                  </Button>
                </div>
              </>
            )}

            {step === "confirm" && (
              <>
                <div className="warning_modal_content">
                  <p className="confirmText">{confirmText}</p>
                  <strong>{city}</strong>
                </div>

                <div className="warning_modal_btn">
                  <Button onClick={handleCancel}>Back</Button>

                  <Button loading={loader} onClick={handleConfirm}>
                    Yes, Confirm
                  </Button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CityWarningModal;